// extracted by mini-css-extract-plugin
export default {"contents":"AF-z","sectionHeading":"BF-z"};